// Validación de RUT Uruguay (12 dígitos, módulo 11).
// Algoritmo DGI: multiplicadores [4,3,2,9,8,7,6,5,4,3,2] sobre los primeros 11 dígitos.
// DV = (11 - (suma mod 11)) mod 11. Si DV calculado === 10 → inválido.

const FACTORES = [4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

/** Limpia un RUT, deja solo dígitos. */
export function limpiarRut(rut) {
  if (!rut) return ''
  return String(rut).replace(/[^0-9]/g, '')
}

/** Valida un RUT Uruguay (módulo 11). Devuelve boolean. */
export function validarRutUY(rut) {
  const limpio = limpiarRut(rut)
  if (limpio.length !== 12) return false
  let suma = 0
  for (let i = 0; i < 11; i++) {
    suma += Number(limpio[i]) * FACTORES[i]
  }
  const dv = Number(limpio[11])
  const dvCalc = (11 - (suma % 11)) % 11
  if (dvCalc === 10) return false
  return dv === dvCalc
}

/** Formatea un RUT para mostrar: "21.234.567.890-3" (visual, opcional). */
export function formatearRut(rut) {
  const limpio = limpiarRut(rut)
  if (limpio.length !== 12) return rut
  return `${limpio.slice(0, 2)}.${limpio.slice(2, 8)}.${limpio.slice(8, 11)}-${limpio.slice(11)}`
}
